var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Chip, ChipDelete, Option, Select } from "@mui/joy";
export var SelectorMultiple = function (_a) {
    var placeholder = _a.placeholder, selectedFilters = _a.selectedFilters, record = _a.record, addedValue = _a.addedValue, onSelectChange = _a.onSelectChange, onDeleteSelect = _a.onDeleteSelect, _b = _a.chipStyle, chipStyle = _b === void 0 ? { background: "rgb(var(--color-green-600))", color: "white" } : _b, _c = _a.chipDeleteStyle, chipDeleteStyle = _c === void 0 ? {
        background: "transparent",
        color: "rgb(var(--color-gray-700))",
    } : _c;
    return (_jsx("div", { children: _jsxs(Select, __assign({ defaultValue: selectedFilters, onChange: onSelectChange, value: selectedFilters, id: "multiple-select", multiple: true, className: "bg-[var(--colors-input-text)]", renderValue: function (selected) { return (_jsx(Box, __assign({ sx: {
                    display: "flex",
                    gap: "0.25rem",
                } }, { children: selected.map(function (selectedOption, index) { return (_jsx(Chip, __assign({ variant: "soft", color: "primary", sx: chipStyle, endDecorator: _jsx(ChipDelete, { sx: chipDeleteStyle, onDelete: function () { return onDeleteSelect(index); } }) }, { children: selectedOption.label }), selectedOption.id)); }) }))); }, sx: {
                minWidth: "11rem",
                "& .Mui-selected": {
                    color: "red", // Replace with your desired color
                },
                //background: "var(--colors-input-text)",
                //border: "none",
                color: "gray",
            }, slotProps: {
                listbox: {
                    sx: {
                        width: "100%",
                        maxHeight: 260,
                        overflow: "auto",
                    },
                },
            }, placeholder: placeholder, indicator: _jsx(FontAwesomeIcon, { icon: faCaretDown }) }, { children: [(record === null || record === void 0 ? void 0 : record.length) === 0 && (_jsx("em", __assign({ className: " text-[var(--colors-label)] text-sm p-2 cursor-pointer" }, { children: "List is empty." }))), record &&
                    (record === null || record === void 0 ? void 0 : record.map(function (element, index) { return (_jsx(Option, __assign({ value: element.id }, { children: element.name }), index)); }).sort(function compare(a, b) {
                        if (a.props.children < b.props.children)
                            return -1;
                        if (a.props.children > b.props.children)
                            return 1;
                        return 0;
                    })), addedValue] })) }));
};
